module.exports = __webpack_public_path__ + "static/locked.020bb393.png";